/**
 * Depoimentos e notas de assinantes.
 * Cole aqui os itens do seu JSON de respostas/notas.
 */
export interface Review {
  id: number;
  nome: string;
  cidade: string;
  nota: number;
  titulo: string;
  comentario: string;
  data: string;
}

export const reviews: Review[] = [
  {
    id: 1,
    nome: 'Ricardo Almeida',
    cidade: 'Araraquara/SP',
    nota: 5,
    titulo: 'Curadoria absurda',
    comentario:
      'Já assinei outros clubes, mas aqui só vem cerveja fora da curva. Dá pra sentir o cuidado.',
    data: '2026-01-05',
  },
  {
    id: 2,
    nome: 'Fernanda Souza',
    cidade: 'Belo Horizonte/MG',
    nota: 5,
    titulo: 'Experiência completa',
    comentario:
      'As cervejas vieram muito bem embaladas e todas excelentes. Virei fã.',
    data: '2026-01-07',
  },
  {
    id: 3,
    nome: 'Gustavo Souza',
    cidade: 'Cambé/PR',
    nota: 5,
    titulo: 'Nível altíssimo',
    comentario:
      'Só rótulo diferenciado. Não é qualquer cerveja artesanal que entra.',
    data: '2025-08-09',
  },
  {
    id: 4,
    nome: 'Carolina Mendes',
    cidade: 'Blumenau/SC',
    nota: 4,
    titulo: 'Muito bom',
    comentario:
      'Gostei muito da seleção. Poderia ter mais conteúdo explicando os estilos.',
    data: '2025-08-10',
  },
  {
    id: 5,
    nome: 'Henrique Duarte',
    cidade: 'Teixeira de Freitas/BA',
    nota: 5,
    titulo: 'Vale cada centavo',
    comentario: 'Chegou perfeito aqui na Bahia. Qualidade excelente.',
    data: '2026-01-12',
  },
  {
    id: 6,
    nome: 'Juliana Prado',
    cidade: 'Recife/PE',
    nota: 5,
    titulo: 'Suporte impecável',
    comentario:
      'Tive dúvida sobre entrega e o suporte respondeu super rápido. Atendimento excelente.',
    data: '2026-01-15',
  },
  {
    id: 7,
    nome: 'Marcelo Teixeira',
    cidade: 'São Paulo/SP',
    nota: 5,
    titulo: 'Clube raiz',
    comentario: 'Nada de cerveja comum. Só artesanal de verdade.',
    data: '2026-01-18',
  },
  {
    id: 8,
    nome: 'Patrícia Nogueira',
    cidade: 'Brasília/DF',
    nota: 5,
    titulo: 'Impressionante',
    comentario: 'Descobri estilos que eu nem conhecia. Curadoria excelente.',
    data: '2026-01-20',
  },
  {
    id: 9,
    nome: 'Rafael Martins',
    cidade: 'Fortaleza/CE',
    nota: 4,
    titulo: 'Muito satisfeito',
    comentario: 'Demorou um pouco pela distância, mas veio perfeito.',
    data: '2026-01-22',
  },
  {
    id: 10,
    nome: 'Camila Rocha',
    cidade: 'Goiânia/GO',
    nota: 5,
    titulo: 'Sempre surpreende',
    comentario: 'Todo mês vem algo que eu não encontraria no mercado comum.',
    data: '2026-01-25',
  },

  {
    id: 11,
    nome: 'Daniel Ferreira',
    cidade: 'Manaus/AM',
    nota: 4,
    titulo: 'Boa experiência',
    comentario: 'Demorou um pouco pra chegar aqui, mas valeu muito a pena.',
    data: '2026-01-27',
  },
  {
    id: 12,
    nome: 'Letícia Ramos',
    cidade: 'Caxias do Sul/RS',
    nota: 5,
    titulo: 'Curadoria impecável',
    comentario: 'Padrão muito acima da média.',
    data: '2026-01-29',
  },
  {
    id: 13,
    nome: 'Eduardo Pinto',
    cidade: 'Caxoeiro do Itapemirim/ES',
    nota: 5,
    titulo: 'Excelente suporte',
    comentario:
      'Precisei alterar endereço e resolveram no mesmo dia. Muito ágeis.',
    data: '2025-11-01',
  },
  {
    id: 14,
    nome: 'Bianca Oliveira',
    cidade: 'Campo Grande/MS',
    nota: 5,
    titulo: 'Experiência premium',
    comentario: 'Clube com padrão elevado mesmo.',
    data: '2025-11-03',
  },
  {
    id: 15,
    nome: 'Thiago Costa',
    cidade: 'Araraquara/SP',
    nota: 3,
    titulo: 'Bom, mas esperava mais',
    comentario: 'Uma das cervejas não fez meu estilo, mas as outras eram boas.',
    data: '2025-11-05',
  },
  {
    id: 16,
    nome: 'Amanda Lopes',
    cidade: 'Natal/RN',
    nota: 5,
    titulo: 'Recomendo demais',
    comentario: 'Muito melhor que comprar artesanal aleatória.',
    data: '2025-09-06',
  },
  {
    id: 17,
    nome: 'Felipe Andrade',
    cidade: 'Cuiabá/MT',
    nota: 4,
    titulo: 'Ótimo custo-benefício',
    comentario: 'Compensa bastante pela qualidade.',
    data: '2025-09-08',
  },
  {
    id: 18,
    nome: 'Larissa Melo',
    cidade: 'Maceió/AL',
    nota: 5,
    titulo: 'Suporte rápido',
    comentario:
      'Enviei mensagem pelo WhatsApp e responderam em minutos. Atendimento top.',
    data: '2025-09-09',
  },
  {
    id: 19,
    nome: 'Bruno Santana',
    cidade: 'João Pessoa/PB',
    nota: 2,
    titulo: 'Esperava mais variedade',
    comentario: 'Achei os estilos muito parecidos entre si.',
    data: '2025-09-10',
  },
  {
    id: 20,
    nome: 'Natália Cardoso',
    cidade: 'Teresina/PI',
    nota: 5,
    titulo: 'Qualidade consistente',
    comentario: 'Assino há meses e o padrão é sempre alto.',
    data: '2025-09-11',
  },

  {
    id: 21,
    nome: 'Rodrigo Alves',
    cidade: 'Rio de Janeiro/RJ',
    nota: 5,
    titulo: 'Só rótulo top',
    comentario: 'Se é pra beber artesanal, que seja nesse nível.',
    data: '2026-02-12',
  },
  {
    id: 22,
    nome: 'Vanessa Martins',
    cidade: 'São Carlos/SP',
    nota: 4,
    titulo: 'Muito bom mesmo',
    comentario: 'Entrega bem embalada e cervejas diferenciadas.',
    data: '2026-02-13',
  },
  {
    id: 23,
    nome: 'Leonardo Silva',
    cidade: 'Macapá/AP',
    nota: 5,
    titulo: 'Chegou perfeito',
    comentario: 'Mesmo longe, chegou impecável.',
    data: '2026-02-14',
  },
  {
    id: 24,
    nome: 'Camila Fernandes',
    cidade: 'Boa Vista/RR',
    nota: 3,
    titulo: 'Boa proposta',
    comentario: 'Gostei da ideia do clube, mas prefiro estilos mais extremos.',
    data: '2026-02-15',
  },
  {
    id: 25,
    nome: 'João Pedro Rocha',
    cidade: 'Palmas/TO',
    nota: 5,
    titulo: 'Confiança total',
    comentario: 'Confio na curadoria. Nunca veio nada fraco.',
    data: '2025-07-16',
  },
  {
    id: 26,
    nome: 'Mariana Alves',
    cidade: 'Aracaju/SE',
    nota: 5,
    titulo: 'Experiência incrível',
    comentario: 'Primeira caixa e já fiquei fã.',
    data: '2025-12-03',
  },
  {
    id: 27,
    nome: 'Pedro Henrique',
    cidade: 'Rio Branco/AC',
    nota: 4,
    titulo: 'Muito satisfeito',
    comentario: 'Demora um pouco pra chegar, mas vale.',
    data: '2025-08-18',
  },
  {
    id: 28,
    nome: 'Gabriela Torres',
    cidade: 'Porto Velho/RO',
    nota: 5,
    titulo: 'Acertaram em cheio',
    comentario: 'Todas excelentes.',
    data: '2026-01-19',
  },
  {
    id: 29,
    nome: 'André Carvalho',
    cidade: 'Curitiba/PR',
    nota: 5,
    titulo: 'Sempre nível alto',
    comentario: 'Nunca recebi cerveja mediana.',
    data: '2026-01-20',
  },
  {
    id: 30,
    nome: 'Isabela Monteiro',
    cidade: 'São Paulo/SP',
    nota: 5,
    titulo: 'Clube sério',
    comentario: 'Entrega exatamente o que promete.',
    data: '2026-01-21',
  },

  {
    id: 31,
    nome: 'Lucas Barros',
    cidade: 'Campinas/SP',
    nota: 5,
    titulo: 'Atendimento diferenciado',
    comentario: 'Equipe super atenciosa. Resolveram minha dúvida rapidamente.',
    data: '2026-02-02',
  },
  {
    id: 32,
    nome: 'Aline Freitas',
    cidade: 'Belo Horizonte/MG',
    nota: 5,
    titulo: 'Muito capricho',
    comentario: 'Desde a embalagem até as cervejas, tudo impecável.',
    data: '2025-11-23',
  },
  {
    id: 33,
    nome: 'Rogério Martins',
    cidade: 'São Paulo/SP',
    nota: 4,
    titulo: 'Boa experiência',
    comentario: 'Gostei bastante, mas uma cerveja não era muito meu perfil.',
    data: '2025-11-08',
  },
  {
    id: 34,
    nome: 'Tatiane Souza',
    cidade: 'Recife/PE',
    nota: 5,
    titulo: 'Excelente escolha',
    comentario: 'Foi presente e a pessoa adorou.',
    data: '2025-10-25',
  },
  {
    id: 35,
    nome: 'Maurício Gomes',
    cidade: 'Curitiba/PR',
    nota: 5,
    titulo: 'Curadoria de respeito',
    comentario: 'Dá pra ver que entendem de cerveja.',
    data: '2026-02-01',
  },
  {
    id: 36,
    nome: 'Beatriz Nunes',
    cidade: 'Salvador/BA',
    nota: 5,
    titulo: 'Suporte muito bom. Pessoal responde rápido!',
    comentario: 'Precisei falar com a equipe e foram muito rápidos e educados.',
    data: '2026-02-03',
  },
  {
    id: 37,
    nome: 'Carlos Eduardo',
    cidade: 'São Carlos/SP',
    nota: 5,
    titulo: 'Excelente padrão',
    comentario: 'Muito acima da média do mercado.',
    data: '2026-02-28',
  },
  {
    id: 38,
    nome: 'Lívia Rocha',
    cidade: 'Fortaleza/CE',
    nota: 4,
    titulo: 'Muito bom',
    comentario: 'Entrega bem feita e cervejas diferenciadas.',
    data: '2025-08-01',
  },
  {
    id: 39,
    nome: 'Renato Silva',
    cidade: 'Porto Alegre/RS',
    nota: 5,
    titulo: 'Vale a assinatura',
    comentario: 'Assinatura que realmente compensa.',
    data: '2025-08-02',
  },
  {
    id: 40,
    nome: 'Débora Alves',
    cidade: 'Brasília/DF',
    nota: 5,
    titulo: 'Atendimento ágil',
    comentario: 'Respostas rápidas no suporte. Isso faz diferença.',
    data: '2025-08-03',
  },

  {
    id: 41,
    nome: 'Vinícius Moraes',
    cidade: 'Goiânia/GO',
    nota: 5,
    titulo: 'Experiência top',
    comentario: 'Todas as cervejas surpreenderam.',
    data: '2025-08-04',
  },
  {
    id: 42,
    nome: 'Elaine Santos',
    cidade: 'Manaus/AM',
    nota: 4,
    titulo: 'Gostei bastante',
    comentario: 'Entrega longa, mas qualidade excelente.',
    data: '2025-08-05',
  },
  {
    id: 43,
    nome: 'Thiago Fernandes',
    cidade: 'São Paulo/SP',
    nota: 5,
    titulo: 'Recomendo muito',
    comentario: 'Já indiquei para vários amigos.',
    data: '2025-09-06',
  },
  {
    id: 44,
    nome: 'Bruna Carvalho',
    cidade: 'Belo Horizonte/MG',
    nota: 5,
    titulo: 'Sempre surpreende',
    comentario: 'Não tem erro. Só cerveja boa.',
    data: '2025-09-07',
  },
  {
    id: 45,
    nome: 'Leandro Souza',
    cidade: 'Rio Claro/PE',
    nota: 2,
    titulo: 'Não fez meu estilo',
    comentario: 'As cervejas eram boas, mas nenhuma combinou muito comigo.',
    data: '2025-09-08',
  },
  {
    id: 46,
    nome: 'Natasha Ribeiro',
    cidade: 'Curitiba/PR',
    nota: 5,
    titulo: 'Muito satisfeita',
    comentario: 'Clube sério e comprometido.',
    data: '2025-09-09',
  },
  {
    id: 47,
    nome: 'Alexandre Costa',
    cidade: 'Rio de Janeiro/RJ',
    nota: 5,
    titulo: 'Excelente atendimento',
    comentario: 'Equipe muito prestativa e rápida nas respostas.',
    data: '2025-09-10',
  },
  {
    id: 48,
    nome: 'Carla Mendes',
    cidade: 'Salvador/BA',
    nota: 5,
    titulo: 'Clube diferenciado',
    comentario: 'Entrega uma experiência completa.',
    data: '2025-12-11',
  },
  {
    id: 49,
    nome: 'Rafael Nogueira',
    cidade: 'Porto Alegre/RS',
    nota: 4,
    titulo: 'Muito bom mesmo',
    comentario: 'Gostei bastante da seleção.',
    data: '2025-12-12',
  },
  {
    id: 50,
    nome: 'Isadora Lima',
    cidade: 'São Paulo/SP',
    nota: 5,
    titulo: 'Padrão altíssimo',
    comentario: 'Entrega qualidade de verdade. Clube diferenciado.',
    data: '2025-12-13',
  },
  {
    id: 51,
    nome: 'Mariana Lopes',
    cidade: 'Campinas/SP',
    nota: 5,
    titulo: 'Seleção impecável',
    comentario:
      'Cada mês chega uma surpresa diferente. A produção é muito bem feita.',
    data: '2026-05-03',
  },
  {
    id: 52,
    nome: 'Gustavo Martins',
    cidade: 'Niterói/RJ',
    nota: 5,
    titulo: 'Virou tradição',
    comentario:
      'Abrir a caixa do clube já virou um dos melhores momentos do mês.',
    data: '2026-05-08',
  },
  {
    id: 53,
    nome: 'Renata Azevedo',
    cidade: 'Uberlândia/MG',
    nota: 3,
    titulo: 'Boa experiência',
    comentario:
      'As cervejas chegaram bem embaladas, mas esperava um pouco mais de variedade.',
    data: '2026-05-14',
  },
  {
    id: 54,
    nome: 'Felipe Moreira',
    cidade: 'Vitória/ES',
    nota: 5,
    titulo: 'Vale muito a pena',
    comentario:
      'Conheci estilos que nunca encontraria facilmente na minha cidade.',
    data: '2026-05-21',
  },
  {
    id: 55,
    nome: 'Camila Rezende',
    cidade: 'Ribeirão Preto/SP',
    nota: 5,
    titulo: 'Sempre uma descoberta',
    comentario:
      'As edições são criativas e dá para perceber o cuidado em cada detalhe.',
    data: '2026-05-29',
  },
  {
    id: 56,
    nome: 'Daniel Ferreira',
    cidade: 'Juiz de Fora/MG',
    nota: 3,
    titulo: 'Bom, mas pode melhorar',
    comentario:
      'Boa comunicação pelo WhatsApp, mas a entrega demorou mais do que eu esperava.',
    data: '2026-06-04',
  },
  {
    id: 57,
    nome: 'Priscila Andrade',
    cidade: 'Santos/SP',
    nota: 5,
    titulo: 'Superou minhas expectativas',
    comentario:
      'Assinei por curiosidade e fiquei pela qualidade e pela variedade.',
    data: '2026-06-09',
  },
  {
    id: 58,
    nome: 'Eduardo Campos',
    cidade: 'Petrópolis/RJ',
    nota: 5,
    titulo: 'Cervejas memoráveis',
    comentario:
      'Já recebi rótulos que entraram para a lista dos meus favoritos.',
    data: '2026-06-15',
  },
  {
    id: 59,
    nome: 'Larissa Monteiro',
    cidade: 'Vila Velha/ES',
    nota: 5,
    titulo: 'Experiência completa',
    comentario:
      'Da embalagem aos rótulos, tudo chega bonito e muito bem preparado.',
    data: '2026-06-20',
  },
  {
    id: 60,
    nome: 'André Faria',
    cidade: 'São José dos Campos/SP',
    nota: 3,
    titulo: 'Curadoria interessante',
    comentario:
      'As informações ajudam na degustação, embora alguns estilos não tenham feito meu gosto.',
    data: '2026-06-27',
  },
  {
    id: 61,
    nome: 'Beatriz Coelho',
    cidade: 'Belo Horizonte/MG',
    nota: 5,
    titulo: 'Meu clube favorito',
    comentario:
      'A qualidade se mantém alta e todo mês tem alguma novidade interessante.',
    data: '2026-07-02',
  },
  {
    id: 62,
    nome: 'Rodrigo Peixoto',
    cidade: 'Rio de Janeiro/RJ',
    nota: 5,
    titulo: 'Recomendo sem medo',
    comentario:
      'Atendimento excelente e uma seleção que realmente foge do comum.',
    data: '2026-07-07',
  },
  {
    id: 63,
    nome: 'Aline Barros',
    cidade: 'Sorocaba/SP',
    nota: 3,
    titulo: 'Experiência razoável',
    comentario:
      'Gostei de alguns rótulos, mas achei as últimas caixas um pouco parecidas.',
    data: '2026-07-12',
  },
  {
    id: 64,
    nome: 'Marcelo Tavares',
    cidade: 'Contagem/MG',
    nota: 5,
    titulo: 'Qualidade de verdade',
    comentario:
      'As cervejas têm personalidade e chegam sempre em ótimas condições.',
    data: '2026-07-01',
  },
  {
    id: 65,
    nome: 'Juliana Freitas',
    cidade: 'Guarapari/ES',
    nota: 5,
    titulo: 'Uma surpresa a cada caixa',
    comentario:
      'O clube transformou minha forma de conhecer e apreciar cervejas artesanais.',
    data: '2026-06-25',
  },
];
